import { Box, Button, useToken } from '@chakra-ui/react';

import { hexToRGBA } from '@/client/utils/hexToRGBA';

interface TabButtonProps {
  label: string;
  status: 'active' | 'inactive';
  count?: number | undefined;
  onClick: () => void;
}

export default function AssignmentTabButton({ label, status, count, onClick }: TabButtonProps) {
  const [brandButton] = useToken('colors', ['brand.button', 'brand.primary']);

  const activeStyles = {
    backgroundColor: 'brand.button',
    color: 'white',
  };

  const inactiveStyles = {
    backgroundColor: 'transparent',
    color: 'neutral.700',
    _hover: {
      backgroundColor: hexToRGBA(brandButton, 0.1),
      color: 'neutral.1300',
    },
  };

  const activeCountStyles = {
    backgroundColor: hexToRGBA('#ffffff', 0.3),
  };

  const inactiveCountStyles = {
    backgroundColor: 'neutral.100',
  };

  return (
    <Button
      fontWeight={500}
      borderRadius="8px"
      paddingY={3}
      paddingX={5}
      sx={status === 'active' ? activeStyles : inactiveStyles}
      onClick={onClick}
    >
      {label}

      {count && (
        <Box
          marginLeft={2}
          paddingY={0}
          paddingX={1}
          borderRadius="4px"
          sx={status === 'active' ? activeCountStyles : inactiveCountStyles}
        >
          {count}
        </Box>
      )}
    </Button>
  );
}
